import { Megaphone, TrendingUp, Headphones, ShoppingCart } from "lucide-react";
import heroImage from "@/assets/hero-person-agent.png";
import ProductHeroI18n from "../shared/ProductHeroI18n";

const AIAgentHero = () => {
  return (
    <ProductHeroI18n
      translationPrefix="aiAgent"
      heroImage={heroImage}
      imageAlt="Chathero AI Agent & Chatbot"
      floatingIcons={[
        { icon: Megaphone, color: "mint" },
        { icon: TrendingUp, color: "orange" },
        { icon: Headphones, color: "primary" },
        { icon: ShoppingCart, color: "mint" },
      ]}
    />
  );
};

export default AIAgentHero;
